import * as React from "react";
import { HistogramPlot, buildHovertemplate, defaultTraceSpec, hovertemplateSpec } from './HistogramPlot.js';
export function HistogramPlotCard({ bins }) {
    const [displayedHistogramType, setDisplayedHistogramType] = React.useState(1);
    return (React.createElement("div", { className: 'card' },
        React.createElement("p", { className: 'cardTitle' },
            "Histogram",
            React.createElement("select", { defaultValue: 1, onChange: e => setDisplayedHistogramType(Number(e.currentTarget.value)) },
                React.createElement("option", { value: 1 }, "hustota (rel.\u010Det. / jedn. osy x)"),
                React.createElement("option", { value: 0 }, "abs. \u010Detnost"),
                React.createElement("option", { value: 2 }, "rel. \u010Detnost"))),
        displayedHistogramType === 0 ? React.createElement(HistogramPlotAbs, { bins: bins }) :
            (displayedHistogramType === 2 ? React.createElement(HistogramPlotRel, { bins: bins }) : React.createElement(HistogramPlotNormalized, { bins: bins }))));
}
// Histogram (abs. četnost)
export function HistogramPlotAbs({ bins }) {
    const traceSpec = React.useMemo(() => defaultTraceSpec, []);
    return (React.createElement(HistogramPlot, { bins: bins, traceSpec: traceSpec }));
}
// Histogram normovaný
export function HistogramPlotNormalized({ bins }) {
    const traceSpec = React.useMemo(() => (Object.assign(Object.assign({}, defaultTraceSpec), { y: (bins) => bins.map(b => b.relFrequencyPerUnit), text: (bins) => bins.map(b => b.relFrequencyPerUnit.toFixed(3)), hovertemplate: buildHovertemplate(["bin", "centre", "relfreqperunit", "emptyextra"], hovertemplateSpec) })), []);
    return (React.createElement(HistogramPlot, { bins: bins, traceSpec: traceSpec }));
}
// Histogram rel č.
export function HistogramPlotRel({ bins }) {
    const traceSpec = React.useMemo(() => (Object.assign(Object.assign({}, defaultTraceSpec), { y: (bins) => bins.map(b => b.relFrequency), text: (bins) => bins.map(b => b.relFrequency.toFixed(3)), hovertemplate: buildHovertemplate(["bin", "centre", "relfreqperunit", "emptyextra"], hovertemplateSpec) })), []);
    return (React.createElement(HistogramPlot, { bins: bins, traceSpec: traceSpec }));
}
//# sourceMappingURL=HistogramPlotCard.js.map